import React from 'react'
import { mount } from 'enzyme'

import { ChipSelector } from '../../elements'

describe("Elements: ChipSelector",() => {
  let result, wrapper
  const props = {
    onClick: () => { result = 'test'},
    remove_border: false,
    active: false
  }

  wrapper = mount(<ChipSelector {...props} />)

  describe("ChipSelector: UI",() => {
    it('Render DOM', () => {
      expect(wrapper.find('.bordered-selector').length).toBe(1)
    })
  })

  describe("ChipSelector: Functions",() => {
    it('onHandleClick()', () => {
      wrapper.instance().onHandleClick()
      expect(result).toBe('test')
    })
  })

})
